export default __webpack_public_path__ + "static/media/arrow-bold-reply-all.fdfea55a.svg";